/* eslint-disable max-len */
const SidebarPageSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `SidebarPageSvg_1_${Date.now()}`;
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="0331嵌入流程图" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="5_流程图_编辑页默认态" transform="translate(-868.000000, -120.000000)">
                    <g id="文档" transform="translate(868.000000, 120.000000)">
                        <rect id="矩形" x="0" y="0" width="18" height="18"></rect>
                        <path d="M4.4,2.5 L11.4,2.5 C13.3329966,2.5 14.9,4.06700338 14.9,6 L14.9,13.4 C14.9,14.559798 13.959798,15.5 12.8,15.5 L5.1,15.5 C3.94020203,15.5 3,14.559798 3,13.4 L3,3.9 C3,3.12680135 3.62680135,2.5 4.4,2.5 Z" id="矩形" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0,0"></path>
                        <line x1="5.8" y1="12.15" x2="11.65" y2="12.15" id="路径-10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></line>
                        <line x1="5.8" y1="9.35" x2="11.65" y2="9.35" id="路径-10备份" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></line>
                        <line x1="5.8" y1="6.55" x2="8.65" y2="6.55" id="路径-10备份-2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></line>
                    </g>
                </g>
            </g>
        </svg>);
};
export default SidebarPageSvg;
